import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { useContent } from '../../content/load';

const Bar = styled.header`
  display: flex;
  align-items: center;
  height: ${(p) => p.theme.layout.nav}px;
  padding: 0 ${(p) => p.theme.layout.gutter}px;
  border-bottom: 1px solid ${(p) => p.theme.color.border.faint};
`;

const Brand = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: ${(p) => p.theme.color.text[0]};
`;

const Mark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: ${(p) => p.theme.color.accent.amber};
  color: ${(p) => p.theme.color.bg[0]};
  font-family: ${(p) => p.theme.font.mono};
  font-weight: 700;
`;

const Main = styled.main`
  min-height: 80vh;
`;

export function MinimalChrome({ children }: { children: ReactNode }) {
  const { site } = useContent();
  return (
    <>
      <Bar>
        <Brand to="/">
          <Mark>{site.brand.mark}</Mark>
          <span>{site.brand.name}</span>
        </Brand>
      </Bar>
      <Main>{children}</Main>
    </>
  );
}
